

import { useEffect, useRef, useState } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { StartIocn } from "../constants/svgPath";
import imagePath from "../constants/imagePath";
import ContactUs from "./Popup/ContactUs";

gsap.registerPlugin(ScrollTrigger);

function HomeSecondSetion() {
     const [isPopupOpen, setIsPopupOpen] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: ".client_sec", // section par animation
          start: "top 80%",       // jab section viewport me 80% top par ho
          end: "bottom 20%",      // optional end
          toggleActions: "play none none reverse", // play on enter, reverse on leave
          markers: false,         // debug markers true karke dekh sakte ho
        },
      });

      tl.from(".client_left p", { y: 20, opacity: 0, duration: 0.5 })
        .from(".client_left h2", { y: 20, opacity: 0, duration: 0.6 }, "-=0.3")
        .from(".client_left figure img", { scale: 0.8, opacity: 0, duration: 0.7 }, "-=0.4")
        .from(".client_rht .client_list", { y: 30, opacity: 0, stagger: 0.2, duration: 0.6 }, "-=0.5")
        .from(".btn_common", { scale: 0.8, opacity: 0, duration: 0.5 }, "-=0.3");
    }, sectionRef);

    return () => ctx.revert(); // cleanup on unmount
  }, []);

  useEffect(() => {
  if (isPopupOpen) {
    document.body.classList.add("body_active");
  } else {
    document.body.classList.remove("body_active");
  }
}, [isPopupOpen]);

  return (
    <>
    
    <section className="client_sec" ref={sectionRef}>
      <div className="contair client_inr">
        <div className="client_left">
          <p><StartIocn />WHAT WE DO</p>
          <h2>Helping Businesses Transform With Smart Technology & Innovation.</h2>
          <picture>
              <source media="(min-width: 1200px)" src={imagePath.ClientRetention} />
              <source media="(max-width: 768px)" src={imagePath.ClientRetention2} />
              <img src={imagePath.ClientRetention} alt="Responsive image" />
            </picture>
          {/* <figure>
            <img src={imagePath.ClientRetention} alt="" />
          </figure> */}
        </div>
        <div className="client_rht">
          <ul className="client_mn">
            <li className="client_list">
              <h3>Business Strategy & Consulting</h3>
              <p>We understand your business challenges and create clear, practical plans to help you work smarter, grow faster, and make confident decisions.</p>
            </li>
            <li className="client_list">
              <h3>Custom Software Development</h3>
              <p>Whether it’s a web or mobile app, we build secure, scalable software designed around your exact needs - using modern technology that works reliably for the long run.</p>
            </li>
            <li className="client_list">
              <h3>Cloud & DevOps Solutions</h3>
              <p>Move to the cloud smoothly and improve your system performance with automation and optimized infrastructure. We help reduce downtime, speed up deployments, and strengthen security.</p>
            </li>
            <li className="client_list">
              <h3>Digital Marketing & Growth</h3>
              <p>Boost your online presence with data-driven marketing. We run targeted campaigns, optimize SEO, and use analytics to increase your reach and deliver measurable results.</p>
            </li>
          </ul>
          <div className="client_btn">

          <button type="button"  onClick={() => setIsPopupOpen(true)}  className="btn_common btn_primry">Book a Free Consultation</button>
          </div>
        </div>
      </div>
    </section>
    
    <ContactUs isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} /></>
  );
};

export default HomeSecondSetion
